async function load_image(url) {
	return new Promise((res, rej) => {
		const image = new Image();
		image.onload = () => res(image);
		image.onerror = err => rej(err || new Error(`Failed to load image ${url}`));
		image.src = url;
	});
}

class TextureImage {

	_gl = null;
	_gor = null;
	_image = null;
	_texture = null;

	constructor(gl, gor, image) {
		this._gl = gl;
		this._gor = gor;
		this._image = image;
		this._texture = gor.createTexture(`Image: ${image.src}`);
		this._texture.assign(this._image, true);
	}

	aspect() {
		return this.width() / this.height();
	}

	width() {
		return this._image.width;
	}

	height() {
		return this._image.height;
	}

	bind(unit = 0) {
		this._texture.bind(unit);
	}

}

export default class ImageFactory {

	_gl = null;
	_gor = null;

	constructor(gl, gor) {
		this._gl = gl;
		this._gor = gor;
	}

	async create(url) {
		return new TextureImage(this._gl, this._gor, await load_image(url));
	}

}
